import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillFacebook,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> US
            </h1>
            {/* <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> C++, Javascript and Go. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Blockchain.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p> */}
            <p className="home-about-body">
Nanosoft is a software development company in Istanbul Turkey, which provides its customers with a full range of software services with a focus on web development, web design, mobile application development and software testing            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND US ON</h1>
    
            <ul className="home-about-social-links">
               <li className="social-icons">
                  <a
                    href="https://www.facebook.com/Nanosoft.programming/"
                    style={{ color: "white" }}
                    target="_blank" 
                    rel="noopener noreferrer"
                                      className="icon-colour  home-social-icons"

                  >
                    <AiFillFacebook />
                  </a>
                </li>
        
                {/* <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/soumyajit4419/"
                    style={{ color: "white" }}
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <AiOutlineWhatsApp />
                  </a>
                </li> */}
                <li className="social-icons">
                  <a
                    href="https://www.instagram.com/nanosoft.programming/"
                    style={{ color: "white" }}
                    target="_blank" 
                    rel="noopener noreferrer"
                                      className="icon-colour  home-social-icons"

                  >
                    <AiFillInstagram />
                  </a>
                </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
